import styled from 'styled-components';
import { Card } from 'antd';
import { COLORS } from '../../../../../../../constants/colors';

const getShadowStyle = (theme) => {
  if (!theme?.shadow_color) return '0 4px 8px rgba(0, 0, 0, 0.1)';

  const hexToRgba = (hex, alpha = 1) => {
    const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16));
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  const softShadowColor = hexToRgba(theme.shadow_color, 0.1);
  const hardShadowColor = hexToRgba(theme.shadow_color, 0.5);

  switch (theme?.card_style) {
    case 'soft-shadow-squared':
    case 'soft-shadow-slightly-rounded':
      return `0 6px 12px ${softShadowColor}`;
    case 'hard-shadow-squared':
    case 'hard-shadow-slightly-rounded':
      return `3px 3px 0 ${hardShadowColor}`;
    case 'outline-squared':
    case 'outline-slightly-rounded':
      return 'none'; // No shadow for outline
    default:
      return `0 4px 8px ${softShadowColor}`;
  }
};

export const VideoProductCard = styled(Card)`
  width: 100%;
  border-radius: ${({ theme }) =>
    theme?.card_style?.includes('slightly-rounded') ? '8px' :
    theme?.card_style?.includes('rounded') ? '15px' : '0'};
  overflow: hidden;
  box-shadow: ${({ theme }) => getShadowStyle(theme)};
  border: ${({ theme }) =>
    theme?.card_style?.includes('outline') ? `2px solid ${theme?.card_color || '#000'}` : 'none'};
  background-color: ${({ theme }) =>
    theme?.card_style?.includes('outline') ? 'transparent' : theme?.card_color || '#ffffff'};

  .ant-card-body {
    padding: 0;
    width: 100%;
  }

  /* Remove this entire block to prevent overriding border */
  /* &.ant-card-bordered {
    border: none !important;
  } */
`;

export const VideoInfo = styled.div`
  padding: 16px;
  background-color: ${({ theme }) =>
    theme?.card_style?.includes('outline') ? 'transparent' : theme?.card_color || '#ffffff'};

  h3 {
    font-size: 18px;
    font-weight: 600;
    color: ${({ theme }) => theme?.card_text_color || '#000000'};
    margin-bottom: 8px;
  }

  p {
    font-size: 14px;
    color: ${({ theme }) => theme?.card_text_color || '#000000'};
    margin: 0;
  }
`;

export const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
`;

export const CarouselWrapper = styled.div`
  .slick-dots {
    bottom: -7px;
  }

  .slick-dots li {
    width: 30px;
    height: 6px;
    margin: 0 4px;
  }

  .slick-dots li button {
    width: 30px;
    height: 10px;
    padding: 0;
    background: ${props => props.theme?.card_text_color || COLORS.$mainBlue};
    opacity: 0.3;
    border-radius: 3px;
  }

  .slick-dots li.slick-active button {
    opacity: 1;
  }

  .slick-dots li button:before {
    display: none;
  }

  /* Optional: Style for next/prev arrows if you're using them */
  .slick-prev, .slick-next {
    font-size: 24px;
    color: ${props => props.theme?.card_text_color || COLORS.$mainBlue};
  }
`;

export const VideoContainer = styled.div`
  width: 100%;
  margin-bottom: 20px;
  position: relative;
`;

export const ScrollableContainer = styled.div`
    display: flex;
    overflow-x: ${props => props.isSingleVideo ? 'hidden' : 'scroll'};
    gap: ${props => props.isSingleVideo ? '0' : '16px'};
    margin-bottom: 20px;
    scroll-snap-type: x mandatory;
    width: 100%;

    &::-webkit-scrollbar {
        display: none;
    }
`;

export const ScrollableItem = styled.div`
    scroll-snap-align: start;
    flex: ${props => props.isSingleVideo ? '1 0 100%' : '0 0 315px'};
    max-width: ${props => props.isSingleVideo ? '100%' : '315px'};
    border-radius: 8px;
    overflow: hidden;
`;

export const ArrowButton = styled.button`
  position: absolute;
  background: white;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
  cursor: pointer;
  z-index: 1;

  &:hover {
    background: #f0f0f0;
  }

  &:focus {
    outline: none;
  }
`;

export const LeftArrow = styled(ArrowButton)`
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
`;

export const RightArrow = styled(ArrowButton)`
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
`;